import React from "react";
import "./index.scss";
import registernowImg from "../../../assets/registernowImg.png";
import { useNavigate } from "react-router";

const HeaderImageSection = () => {
  let navigate = useNavigate();
  return (
    <section className="sectionWrapper desktopView">
      <div className="contentWrapper w-100">
        <div className="row">
          <div className="col-sm-5 text-white">
            <div className="mb-2">
              More Than 5,000 new Registration every Year{" "}
            </div>
            <div className="mb-2">
              » Our application is only for Kumbhar Caste{" "}
            </div>
            <div className="mb-2">
              » Profile Matching & Express Interest facilitie sare available
            </div>
            <div className="mb-2">
              » No need to register your name with any other application
            </div>
            <div className="mb-2">
              » Thousands of marriages are settled through our application as of
              today
            </div>
          </div>
          <div className="col-sm-2 registerImg">
            <img src={registernowImg} alt="" />
          </div>
          <div className="col-sm-5 d-flex align-items-center justify-content-center">
            <span className="buttonClass"
            onClick={() => {
              navigate("/register");
            }}
            >
              CLICK HERE TO REGISTER YOURSELF NOW
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeaderImageSection;
